import { FunctionComponent, ReactNode } from 'react';
import { twMerge } from 'src/utils/twMerge';

export const PAGE_X = 'px-4';
export const PAGE_BLEED = '-mx-4';

type Props = {
  left?: ReactNode;
  title?: ReactNode;
  subtitle?: ReactNode;
  right?: ReactNode;
  children?: ReactNode;
  isOnDark?: boolean;
  isCentreWide?: boolean;
  className?: string;
  'data-testid'?: string;
};

const PageHeader: FunctionComponent<Props> = ({
  left,
  title,
  subtitle,
  right,
  children,
  isOnDark = false,
  isCentreWide = false,
  className,
  'data-testid': testId = 'page-header',
}) => {
  const hasTitle = Boolean(title) || Boolean(subtitle);
  const sideClassName = hasTitle
    ? 'flex-1 basis-0'
    : twMerge('min-w-6 shrink-0', isCentreWide && 'min-w-0 empty:hidden');

  return (
    <header
      className={twMerge(
        'relative flex h-16 w-full shrink-0 items-center gap-4',
        PAGE_X,
        className,
      )}
      data-testid={testId}
    >
      <div className={twMerge('flex items-center gap-4', sideClassName)}>
        {left}
      </div>
      {hasTitle ? (
        <div className="flex min-w-0 flex-col items-center text-center">
          {title && (
            <h1
              className={twMerge(
                'm-0 w-full truncate text-2xl font-bold text-structural-darkest',
                isOnDark && 'text-white',
              )}
            >
              {title}
            </h1>
          )}
          {subtitle && (
            <div
              className={twMerge(
                'w-full truncate text-sm font-semibold text-structural-dark',
                isOnDark && 'text-white',
              )}
            >
              {subtitle}
            </div>
          )}
        </div>
      ) : (
        <div className="flex min-w-0 flex-1 items-center justify-center">
          {children}
        </div>
      )}
      <div
        className={twMerge('flex items-center justify-end gap-4', sideClassName)}
      >
        {right}
      </div>
    </header>
  );
};

export default PageHeader;
